/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Community_Mock_Msg_ZeynepInputs */

const tr_landing_community_mock_msg_zeynep = /** @type {(inputs: Landing_Community_Mock_Msg_ZeynepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message Agent Almanca çevirisini de yapıyor mu? 🤔`)
};

const en_landing_community_mock_msg_zeynep = /** @type {(inputs: Landing_Community_Mock_Msg_ZeynepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does Message Agent also do German translations? 🤔`)
};

const de_landing_community_mock_msg_zeynep = /** @type {(inputs: Landing_Community_Mock_Msg_ZeynepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersetzt der Message Agent auch ins Deutsche? 🤔`)
};

const ru_landing_community_mock_msg_zeynep = /** @type {(inputs: Landing_Community_Mock_Msg_ZeynepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message Agent переводит и на немецкий? 🤔`)
};

/**
* | output |
* | --- |
* | "Does Message Agent also do German translations? 🤔" |
*
* @param {Landing_Community_Mock_Msg_ZeynepInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_community_mock_msg_zeynep = /** @type {((inputs?: Landing_Community_Mock_Msg_ZeynepInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Community_Mock_Msg_ZeynepInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_community_mock_msg_zeynep(inputs)
	if (locale === "de") return de_landing_community_mock_msg_zeynep(inputs)
	if (locale === "ru") return ru_landing_community_mock_msg_zeynep(inputs)
	return tr_landing_community_mock_msg_zeynep(inputs)
});